<template>
  <div>
    <CandidateInterviewProcessing v-if="isOfficeInterviewProcessing" />
    <CandidateInterviewProcessingFailed v-else-if="isOfficeInterviewProcessingFailed" />
    <template v-else-if="showOfficeInterviewPlayer">
      <template v-if="candidate.quotaWrittenOff">
        <CandidateInterviewOffice
          v-model="officeInterviewPlayerTime"
          :interview="interview"
        />
      </template>
      <template v-else>
        <InterviewsQuotaExceededCandidate>
          <AppWithLoading :fetch="openCurrentCandidate">
            <CandidateInterviewOffice
              v-model="officeInterviewPlayerTime"
              :interview="interview"
            />
          </AppWithLoading>
        </InterviewsQuotaExceededCandidate>
      </template>
    </template>
  </div>
</template>

<script>
import { interviewStatusType } from '@/enums';
import InterviewsQuotaExceededCandidate
  from '@/components/Payment/Quota/InterviewsQuotaExceededCandidate';
import useCandidates from '@/compositions/useCandidates';
import { toRefs } from '@vue/composition-api';
import AppWithLoading from '@/components/AppWithLoading';
import CandidateInterviewProcessing from '../CandidateInterviewProcessing.vue';
import CandidateInterviewOffice from '../CandidateInterviewOffice.vue';
import CandidateInterviewProcessingFailed from '../CandidateInterviewProcessingFailed.vue';

export default {
  name: 'UploadedVideoInterview',
  components: {
    AppWithLoading,
    InterviewsQuotaExceededCandidate,
    CandidateInterviewProcessingFailed,
    CandidateInterviewOffice,
    CandidateInterviewProcessing,
  },
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    interview: {
      required: true,
    },
  },
  setup(props) {
    const { openCandidate } = useCandidates();
    const { candidate } = toRefs(props);

    async function openCurrentCandidate() {
      await openCandidate(candidate.value?.id);
    }

    return {
      openCurrentCandidate,
    };
  },
  computed: {
    officeInterviewPlayerTime: {
      get() {
        return this.$store.state.candidatePage.officeInterviewPlayerTime;
      },
      set(value) {
        this.$store.commit('candidatePage/setOfficeInterviewPlayerTime', value);
      },
    },
    showOfficeInterviewPlayer() {
      return this.interview
        && this.interview.status === interviewStatusType.READY;
    },
    isOfficeInterviewProcessing() {
      return this.interview
        && (this.interview.status === interviewStatusType.PROCESSING
        || this.interview.status === interviewStatusType.BLANK);
    },
    isOfficeInterviewProcessingFailed() {
      return this.interview
        && this.interview.status === interviewStatusType.PROCESSING_FAILED;
    },
  },
};
</script>

<style scoped>

</style>
